/* eslint-disable tailwindcss/no-arbitrary-value */
import classNames from 'classnames';
import SeedlyIcon from './icons/SeedlyIcon';
import StarIcon from './icons/StarIcon';
import Tooltip from './Tooltip';

interface RatingProps {
  score: string | number;
  info?: string;
  max?: string | number;
  mode?: 'horizontal' | 'vertical';
  starView?: boolean;
  className?: string;
}

export const Rating: React.FC<RatingProps> = ({
  score,
  info = '',
  max = 5,
  mode = 'horizontal',
  className,
  starView = true,
}: RatingProps) => {
  return (
    <div
      className={classNames(
        'mhg-alpha-bullet-1 flex items-center',
        {
          '!items-start': mode === 'vertical',
        },
        className,
      )}
    >
      <div
        className={classNames('mhg-alpha-bullet-1 flex items-center gap-2', {
          'flex-col !items-start': mode === 'vertical',
        })}
      >
        <div className="flex items-center gap-1 md:gap-2">
          <SeedlyIcon className="w-12 md:w-auto" />
          <span className="mhg-alpha-body-2 md:mhg-alpha-body-1 text-nowrap text-text/secondary">
            rating
          </span>
        </div>

        <div className="flex items-center gap-1">
          {starView && <StarIcon className="text-[#2955DE]" />}
          <span className="mhg-alpha-bullet-2 md:mhg-alpha-bullet-1 text-[#2955DE]">
            {score}
          </span>
          <span className="mhg-alpha-body-2 md:mhg-alpha-body-1 text-text/secondary">
            / {max}
          </span>
        </div>
      </div>

      {info && (
        <div className="ml-1">
          <Tooltip content={info} />
        </div>
      )}
    </div>
  );
};
